import { createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-482bcb4c")

_pushScopeId("data-v-482bcb4c")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "button button--action" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-plus-circled" })
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("span", null, "Ajouter un commanditaire", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "update__title",
    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addSponsor && _ctx.addSponsor(...args)), ["stop"]))
  }, [
    _hoisted_1,
    _hoisted_2
  ]))
})